import { render, staticRenderFns } from "./expenses-gen.vue?vue&type=template&id=617aa6c8&scoped=true"
import script from "./expenses-gen.vue?vue&type=script&lang=js"
export * from "./expenses-gen.vue?vue&type=script&lang=js"
import style0 from "./expenses-gen.vue?vue&type=style&index=0&id=617aa6c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617aa6c8",
  null
  
)

export default component.exports